import React from 'react';
export function TopBanner() {
  return <div className="w-full bg-[#0F4226] text-white py-3" data-id="element-272">
      <div className="max-w-3xl mx-auto px-4 flex flex-col items-center justify-center gap-2" data-id="element-273">
        <img src="https://getfurlife.com/cdn/shop/files/Logos_22_1_d9cfa4cd-ac51-41cc-86ca-0ba800a0554d.png?v=1676576942" alt="FurLife™" className="h-8 object-contain" data-id="element-274" />
        <p className="text-xs font-sans uppercase tracking-wider opacity-80" data-id="element-275">
          Advertorial
        </p>
      </div>
    </div>;
}